// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2KyyO","paramInput":"JobSimulator_paramInput__h6MhC","input":"JobSimulator_input__2SSrR"};